export type Platform = 'web' | 'ios' | 'android';

export function getPlatform(): Platform {
  // Capacitor will inject this when running as native app
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const capacitor = (window as any).Capacitor;
  
  // Check for Capacitor native runtime
  if (capacitor?.isNativePlatform?.()) {
    if (capacitor.getPlatform() === 'ios') return 'ios';
    if (capacitor.getPlatform() === 'android') return 'android';
  }
  
  return 'web';
}

export function isNative(): boolean {
  return getPlatform() !== 'web';
}

export function isIOS(): boolean {
  return getPlatform() === 'ios';
}

export function isAndroid(): boolean {
  return getPlatform() === 'android';
}
